// src/components/customer/CustomerAIHub.jsx
// Floating AI icon for the Customer Portal — bottom-right fixed position,
// same layout approach as the Admin BespokeAIHub but without the spokes.
// Clicking navigates directly to the Customer AI Assistant page.
// Dimmed when bespokeai module is not enabled for the salon.
import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import '../../styles/customer-ai-agent.css';

function CustomerAIHub({ aiEnabled }) {
  const navigate  = useNavigate();
  const { salonId } = useParams();
  const location  = useLocation();

  const isOnAIPage = location.pathname.includes('/ai');

  const handleClick = () => {
    if (!aiEnabled) return;
    navigate(`/BespokeBeauty/${salonId}/customer/ai`);
  };

  return (
    <div className="cpa-hub-root">
      <button
        className={`cpa-hub-btn${isOnAIPage ? ' cpa-hub-btn--active' : ''}${!aiEnabled ? ' cpa-hub-btn--dim' : ''}`}
        onClick={handleClick}
        title={aiEnabled ? 'Open AI Assistant' : 'AI Assistant — not available for this salon'}
        aria-label="Open AI Assistant"
        disabled={!aiEnabled}
      >
        <img
          src="/bespoke-ai-chip.jpg"
          alt="AI Assistant"
          className="cpa-hub-img"
          draggable="false"
        />
      </button>
    </div>
  );
}

export default CustomerAIHub;
